import { Plus } from '#app/components/icons/solid'
import { useState } from 'react'
import { useNavigate } from 'react-router'
import { ButtonUtility } from '#app/components/base/buttons/button-utility.tsx'
import { usePreserveNuqsParams } from '#app/utils/navigation.ts'
import { useWorkspaceId } from '#app/utils/user.ts'
import { IconSetForm } from './icon-set-form'
import { DialogTrigger, ModalOverlay, Modal, Dialog } from './modal'

export function NewIconSetModal({ trigger }: { trigger: React.ReactNode }) {
	const [isOpen, setIsOpen] = useState(false)
	const navigate = useNavigate()
	const buildUrl = usePreserveNuqsParams()
	const workspaceId = useWorkspaceId()

	return (
		<DialogTrigger isOpen={isOpen} onOpenChange={setIsOpen}>
			{trigger}

			<ModalOverlay isDismissable>
				<Modal className="w-full max-w-3xl">
					<Dialog className="p-0">
						<IconSetForm
							mode="create"
							onClose={() => setIsOpen(false)}
							onSuccess={(data) => {
								if (workspaceId) {
									void navigate(
										buildUrl(`/workspace/${workspaceId}/icon-sets/${data.id}`),
									)
								}
							}}
						/>
					</Dialog>
				</Modal>
			</ModalOverlay>
		</DialogTrigger>
	)
}
